export const dataResearchThemes = [
  {
    "title": "reasoning and learning for robotics",
      "content": [ /*
      "vision-based imitation learning",
      "bayesian inverse reinforcement learning",
      "planning and control under uncertainty in cost and dynamics",
      "shared human-robot autonomy",
      "continual/lifelong learning for control",
      "differentiable simulators",
      "simulation-based inference",
      "system identification" */
    ],
      //"asset":"assets/research-themes/machine learning.jpg",
      "web": "/research/reasoning-and-learning-for-robotics"
  },
  {
    "title": "safe robot learning",
    "content": [ /*
      "safe exploration in reinforcement learning",
      "physical adversarial examples in robotics",
      "backwards reachability",
      "robust control",
      "safe system identification"*/
    ],
      //"asset":"assets/research-themes/safe robot learning.jpg",
      "web": "/research/safe-robot-learning"
  },
  {
    "title": "3D vision \& generative models for simulation",
    "content": [ /*
      "safe exploration in reinforcement learning",
      "physical adversarial examples in robotics",
      "backwards reachability",
      "robust control",
      "safe system identification"*/
    ],
      //"asset":"assets/research-themes/todo.jpg",
      "web": "/research/generative-models-and-perception"
  },
]


export const dataApplicationAreas = [
  {
    "title": "robotics for chemistry and biology lab automation",
      "content": [ /* [
      "robots for scientific exploration",
      "visual exploration",
      "visual similarity search",
      "contrastive representation learning",
      "3d vision and perception",
      "active sampling and information gathering",
      "collaborative human-robot environmental monitoring",
      "field robotics", */
    ],
     // "asset":"assets/research-themes/todo.jpg",
      "web": "/research/robotics-for-chemistry-and-biology-lab-automation"
  },
  {
    "title": "  field robotics for environmental monitoring  ",
      "content": [ /* [
      "robots for scientific exploration",
      "visual exploration",
      "visual similarity search",
      "contrastive representation learning",
      "3d vision and perception",
      "active sampling and information gathering",
      "collaborative human-robot environmental monitoring",
      "field robotics", */
    ],
      //"asset":"assets/research-themes/field_robotics.jpg",
      "web": "/research/field-robotics"
  },
]
